// Task #1972 / #2040 — which mask tool a goal-picker goal SUGGESTS.
// Suggestion only, never a lock-out: the brush/click toggle stays usable.
//
// Task #2040: "Remove something" no longer flips the tool to Click select —
// removal routing rides the per-region intent tag regardless of tool, and
// users report the brush works better for removals. So "remove" (like
// "describe") keeps whatever tool is currently active; only the text/style
// goals still suggest the brush.
export type EditGoal = "remove" | "edit_text" | "style" | "describe";
export type MaskTool = "brush" | "click";

export function suggestedMaskToolForGoal(
  goal: EditGoal,
  currentTool: MaskTool,
): MaskTool {
  if (goal === "edit_text" || goal === "style") return "brush";
  return currentTool;
}
